<template>
  <div class="content">
      <el-timeline >
        <el-timeline-item  placement="top" v-for="item in list" :key="item.id">
          <el-card>
            <h4>{{ item.change_log }}</h4>
            <p>{{ item.create_time }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
  </div>
</template>
<script>
import{getCustomerCaseLogList}from '@/api/client';

export default {
  name: 'ClassifyList',
  data () {
    return {
      list: [], // 数据展示
    }
  },

  mounted () {
    this.getList();
  },
  methods: {
    // 获取列表
    getList () {
      getCustomerCaseLogList({id:this.$route.query.caseId}).then(res => {
        this.list = res.data.list;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-timeline{
  width: 80%;
}
</style>
